/* eslint-disable arrow-body-style */
import React from "react";

type Props = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

export const TabPanel: React.FC<Props> = ({ children, value, index }) => {
  return value === index ? (
    <div role='tabpanel' style={{ height: "100%" }}>
      {children}
    </div>
  ) : null; // démonte quand inactif
};
